module.exports = __webpack_public_path__ + "resources/img/img_rancher.c54f979ddc2c42088c28d24bab5e3847.png";